import { compose, set, lensProp } from 'ramda';
import { formatPhone } from '../../../helpers/formatters';

import {
  SET_USER,
  SET_USER_ID,
  SET_IS_ADMIN_USER,
  SET_USER_MFA,
  SET_USER_RESALE_ID,
  CLEAR_PASSWORD,
  CLEAR_BASIC_INFORMATION,
  HANDLE_LOADING,
  SET_USER_RESTRICTIONS,
  SET_IS_CONSULT_NEW_PASSWORD_TERMS_REQUEST_DONE,
  SET_IS_CONSULT_USER_NEW_PASSWORD_TERMS_REQUEST_DONE,
  SET_USER_OWN_TERMS,
  SET_IS_USER_TERMS_NOT_ACCEPTED
} from './constants';

const defaultState = {
  userId: null,
  resaleId: null,
  isLoading: false,
  isConsultNewPasswordTermsRequestDone: false,
  isConsultUserNewPasswordTermsRequestDone: false,
  userRestrictions: [],
  mfa: {
    canDisableEmail2fa: 0,
    email2faEnabled: 0,
    email2faRequired: 0
  },
  userOwnTerms: [],
  userTermsNotAccepted: [],
  isMobile: false,
  submit: {
    isAdminUser: 0,
    profileId: 2,
    name: '',
    email: '',
    emailConfirm: '',
    phone: '',
    password: '',
    passwordConfirm: '',
    termsOfUse: false,
    recaptcha: false
  }
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_USER: {
      const { name, email, phone } = action.data;
      const user = compose(
        set(lensProp('name'), name),
        set(lensProp('email'), email),
        set(lensProp('phone'), formatPhone(phone))
      );

      return {
        ...state,
        submit: user(state.submit),
        isLoading: false
      }
    }
    case SET_USER_ID: {
      return {
        ...state,
        userId: action.userId
      }
    }
    case SET_IS_ADMIN_USER: {
      return {
        ...state,
        submit: {
          ...state.submit,
          isAdminUser: action?.isAdminUser
        }
      }
    }
    case SET_USER_MFA: {
      return {
        ...state,
        mfa: action?.data
      }
    }
    case SET_USER_RESALE_ID: {
      return {
        ...state,
        resaleId: action.resaleId
      }
    }
    case CLEAR_PASSWORD: {
      return {
        ...state,
        submit: {
          ...state.submit,
          password: '',
          passwordConfirm: ''
        }
      }
    }
    case HANDLE_LOADING: {
      return {
        ...state,
        isLoading: action.status
      }
    }
    case SET_USER_RESTRICTIONS: {
      return {
        ...state,
        userRestrictions: action.userRestrictions,
        submit: {
          ...state.submit,
          profileId: action.profileId
        }
      }
    }
    case SET_IS_CONSULT_NEW_PASSWORD_TERMS_REQUEST_DONE: {
      return {
        ...state,
        isConsultNewPasswordTermsRequestDone: true
      }
    }
    case SET_IS_CONSULT_USER_NEW_PASSWORD_TERMS_REQUEST_DONE: {
      return {
        ...state,
        isConsultUserNewPasswordTermsRequestDone: true
      }
    }
    case SET_USER_OWN_TERMS: {
      return {
        ...state,
        userOwnTerms: action?.data
      }
    }
    case SET_IS_USER_TERMS_NOT_ACCEPTED: {
      return {
        ...state,
        userTermsNotAccepted: action?.data
      }
    }
    case CLEAR_BASIC_INFORMATION: {
      return defaultState;
    }
    default: {
      return state;
    }
  }
}